/**
 * Created by neo on 18.12.20.
 */
import { makeAutoObservable } from 'mobx';

export type WeightPerServing = {
  amount: number;
  unit: string;
};

export function createWeightPerServing(json?: Partial<WeightPerServing>): WeightPerServing {
  return makeAutoObservable({
    amount: json?.amount ?? 0,
    unit: json?.unit ?? '',
  });
}
